const en_master_itemtag = {
    "": "item tag",
    add: "add item tag",
    edit: "edit item tag",
    name: "item tag name",

    error: {
        create: "Failed to create item tag.",
        delete: "Failed to delete item tag.",
        edit: "Failed to update item tag.",
        name: "Item tag name cannot be empty."
    },

    success: {
        create: "Item tag created successfully.",
        delete: "Item tag deleted successfully.",
        edit: "Item tag updated successfully.",
    }
}

export default en_master_itemtag